var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 8.17754C16.0008 7.51977 15.9464 7.03976 15.8285 6.54199H8.16406V9.51086H12.6629C12.5722 10.2487 12.0824 11.3598 10.994 12.1064L10.9787 12.2058L13.4021 14.0456L13.57 14.062C15.1119 12.6664 16.0008 10.6131 16.0008 8.17754Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16366 15.9998C10.3677 15.9998 12.218 15.2887 13.5696 14.062L10.9936 12.1064C10.3042 12.5776 9.37905 12.9064 8.16366 12.9064C6.00493 12.9064 4.17274 11.5109 3.51961 9.58203L3.42388 9.59L0.904047 11.5011L0.871094 11.5909C2.21349 14.2042 4.97087 15.9998 8.16366 15.9998Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51925 9.58242C3.34692 9.08465 3.24718 8.55127 3.24718 8.00019C3.24718 7.44904 3.34692 6.91573 3.51018 6.41795L3.50562 6.31194L0.954208 4.37012L0.87073 4.40903C0.317465 5.49349 0 6.7113 0 8.00019C0 9.28908 0.317465 10.5068 0.87073 11.5913L3.51925 9.58242Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16366 3.09332C9.69652 3.09332 10.7305 3.74221 11.3201 4.28447L13.624 2.08001C12.209 0.791117 10.3677 0 8.16366 0C4.97087 0 2.21349 1.79555 0.871094 4.40887L3.51055 6.41779C4.17274 4.4889 6.00493 3.09332 8.16366 3.09332Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d7c887feec4d8c8d6f743951866670cc.svg";
export { ForwardRef as ReactComponent };